<template>
    <AppModal :name="name" :onEnterKeyPress="() => $modal.hide(name)">
        <template slot="header">
            Congratulations your account is now secure
        </template>
        <template slot="content">
            <p>You will now be prompted to enter you two-factor code each time you login</p>
            <img src="/img/2FA.png" height="140px" alt="Success 2FA">
        </template>
        <template slot="actions">
            <div class="row justify-content-end mx-0 mt-3">
                <button @click="$modal.hide(name)" class="btn btn-link">Continue</button>
            </div>
        </template>
    </AppModal>
</template>

<script>
import AppModal from '../../../components/shared/AppModal'

export default {
    name: 'SuccessfulTwoFactorEnabling',
    components: {AppModal},
    props: {
        name: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped>
</style>
